import { AuthDirectRequestVerificationCodeQuery } from '@cibo/core'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

import {
  useLoginWithVerificationCode,
  useRequestPasswordResetCode,
} from '../../queries/useForgotPassword'
import { CreateNewPasswordForm, CreateNewPasswordFormValues } from './CreateNewPasswordForm'
import { RequestCodeForm } from './RequestCodeForm'

export const ForgotPassword = () => {
  const { search } = useLocation()
  const params = new URLSearchParams(search)
  const [formAuthToken, setFormAuthToken] = useState(
    !!params.get('formAuthToken') ? params.get('formAuthToken') : undefined
  )
  const [enabled, setEnabled] = useState(params.get('formAuthToken') === null)
  const [username, setUsername] = useState(
    params.get('username') !== null ? (params.get('username') as string) : undefined
  )
  const requestPasswordResetCode = useRequestPasswordResetCode(
    { username },
    { enabled: !!username && enabled }
  )
  const loginWithVerificationCode = useLoginWithVerificationCode()

  useEffect(() => {
    enabled && setFormAuthToken(requestPasswordResetCode.data?.formAuthToken)
  }, [requestPasswordResetCode.data?.formAuthToken, enabled])

  const onSubmitCodeAndPassword = (values: CreateNewPasswordFormValues) => {
    !!username &&
      !!formAuthToken &&
      loginWithVerificationCode.mutateAsync({
        ...values,
        username,
        formAuthToken,
      })
  }

  const onSubmitRequestCode = (values: AuthDirectRequestVerificationCodeQuery) =>
    setUsername(values.username)

  const handleResendCode = () => {
    setEnabled(true)
    requestPasswordResetCode.refetch()
  }

  if (!!formAuthToken && username) {
    return (
      <CreateNewPasswordForm
        verifyCode={params.get('code') !== null ? (params.get('code') as string) : undefined}
        isLoading={loginWithVerificationCode.isLoading || requestPasswordResetCode.isFetching}
        error={requestPasswordResetCode.error || loginWithVerificationCode.error}
        onResendCode={handleResendCode}
        onSubmit={onSubmitCodeAndPassword}
      />
    )
  } else {
    return (
      <RequestCodeForm
        loading={requestPasswordResetCode.isFetching}
        error={requestPasswordResetCode.error}
        onSubmit={onSubmitRequestCode}
      />
    )
  }
}
